import React from "react";
import { useSelector } from "react-redux";
import v from "../../package.json";
import { FaFacebookF } from "react-icons/fa";

function Footer() {
  const store = useSelector((state) => state.auth.store);
  const link = useSelector((state) => state.auth.link);
  return (
    <footer>
      <div className="container">
        <div className="col-sm-3">
          <h2 className="widgettitle">संपर्क करे</h2>{" "}
          <div className="textwidget">
            <ul className="address">
              <li>
                <i className="fa fa-home"></i>
                {store.store_address}
              </li>
              <li>
                <i className="fa fa-phone"></i>
                {store.store_phone}
              </li>
              <li>
                <i className="fa fa-envelope"></i>
                {store.store_email}
              </li>

              
            </ul>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="contactus">
            <h2 className="widgettitle">क्विक लिंक</h2>
            <div className="menu-footer-menu-container">
              <ul id="menu-footer-menu" className="menu">
                <li
                  id="menu-item-1754"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-1754"
                >
                  <a href="/">Home</a>
                </li>
                <li
                  id="menu-item-1755"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1755"
                >
                  <a href="/">Careers</a>
                </li>
                <li
                  id="menu-item-1757"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1757"
                >
                  <a href="/">Events</a>
                </li>
                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a href="/">Contact Us</a>
                </li>

                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a href="https://aicte.gov.in/" target="_blank">
                    AICTE
                  </a>
                </li>
                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a
                    href="https://rscl.nscd.gov.in/en_US/upcst/"
                    target="_blank"
                  >
                    UGC
                  </a>
                </li>
                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a
                    href="https://rusa.nic.in/
"
                    target="_blank"
                  >
                    RUSA
                  </a>
                </li>
                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a
                    href="https://pmusha.education.gov.in/pm-usha/#/home
"
                    target="_blank"
                  >
                    UP USHA
                  </a>
                </li>
                <li
                  id="menu-item-1756"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1756"
                >
                  <a href="https://ugcnet.nta.ac.in/" target="_blank">
                    UP.CST
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="contactus">
            <h2 className="widgettitle">Useful Links</h2>
            <ul>
              {/* {link.map((lin)=>
        <>
            <li key={lin.id}>
              <a href={lin.link} style={{color:'white'}} target='_blank'>{lin.name}</a>
            </li>
        </>)}   */}

              <li>
                <a
                  href="https://bujhansiadm.samarth.edu.in/"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  University Admissions Portal : Samarth Portal
                </a>
              </li>

              <li>
                <a
                  href="https://content.acetians.in/uploads/Regarding%20Admission%20Candidate%20Userguide%20-%20Samarth%2012062025140400609A%2012-06-2025%20(1).pdf"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  Student Admission User Activity Samarth
                </a>
              </li>

              <li>
                <a
                  href="https://content.acetians.in/uploads/Regarding%20Admission%20Candidate%20Userguide%20-%20Samarth%2012062025140409964B%2012-06-2025%20(1).pdf"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  Student Admission User Guide Samarth{" "}
                </a>
              </li>
              <li>
                <a
                  href="http://www.youtube.com/@DHEprayag"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  E-Learning by Directorate of Higher Education
                </a>
              </li>
              <li>
                <a
                  href="https://uphed.gov.in/"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  Directorate of Higher Education. UP
                </a>
              </li>

              <li>
                <a
                  href="https://swayam.gov.in/"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  Swayam portal
                </a>
              </li>
              <li>
                <a
                  href="https://www.bujhansi.ac.in/en
"
                  style={{ color: "white" }}
                  target="_blank"
                >
                  Bundelkhand university
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-sm-3">
          <div className="contactus">
            <h2 className="widgettitle">हमारे बारे में</h2>{" "}
            <div className="textwidget">
              <p>{store.store_description}</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p
          style={{
            color: "white",
            paddingBlockStart: "10px",
            borderTop: "1px solid white",
            textAlign: "center",
          }}
        >
          Developed By{" "}
          <a
            style={{ color: "inherit" }}
            href="https://acetians.com"
            target="_blank"
          >
            Acetians Technologies
          </a>
        </p>
      </div>
      <p>{v.version}</p>
    </footer>
  );
}

export default Footer;
